<template>
  <div class="overflow-x-auto">
    <table class="external-transactions-table">
      <thead class="mb-2">
        <tr class="h-[30px]">
          <th class="head" v-for="(header, index) in tableHeaders" :key="index">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody class="body">
        <tr
          v-for="(item, index) in transactions"
          :key="item.orderId || index"
          :class="[rowClasses(item, index), { 'new-transaction': isNew(item.createdAt) }]"
          class="row"
        >
          <td class="date text-xs rounded-r-xl px-2">{{ persianDate(item.createdAt) }}</td>
          <td class="date text-xs text-green-500 font-semibold">{{ item.desc }}</td>
          <td class="date text-xs text-green-500 font-semibold">{{ item.orderId }}</td>
          <td class="date text-xs text-green-500 font-semibold">
            {{ item.username || item.beneficiaryName }}
          </td>
          <td class="date text-xs font-semibold">{{ item.email }}</td>
          <td class="date text-xs font-semibold">{{ item.sender || item.cardNumber }}</td>
          <td class="date text-xs font-semibold">{{ item?.gateway?.title }}</td>
          <td class="date text-xs font-semibold">{{ item?.type }}</td>
          <td :class="transactionStyle(item.status)" class="date text-xs font-semibold">
            {{ transactionStatus(item.status) }}
          </td>
          <td class="date text-custom_blue text-sm font-semibold rounded-l-xl px-2">
            {{ FormatPersianAmount(item.amount) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { PersianDate } from '@/Utils/persian-date';

export default {
  name: 'ExternalTransactionsTableComponent',

  props: {
    transactions: { type: Array, required: true }
  },

  data() {
    return {
      persianDateConverter: new PersianDate(),
      tableHeaders: [
        'تاریخ و ساعت',
        'توضیحات',
        'کد رهگیری',
        'نام کاربری',
        'شماره موبایل',
        'کاربر',
        'درگاه',
        'درگاه سیستم',
        'وضعیت',
        'مبلغ (تومان)'
      ],
      now: Date.now() // will be updated every second
    };
  },

  computed: {
    // No need for computed array – we use method in template
  },

  methods: {
    // Check if transaction is less than 3 minutes old
    isNew(createdAt) {
      const created = new Date(createdAt).getTime();
      const threeMinutes = 2 * 60 * 1000;
      return this.now - created < threeMinutes;
    },

    rowClasses(item, index) {
      const stripe = index % 2 === 0 ? 'bg-gray-200' : 'bg-transparent';
      return stripe;
    },

    persianDate(utcDateTime) {
      return this.persianDateConverter.convert(utcDateTime, true);
    },

    FormatPersianAmount(amount) {
      const num = typeof amount === 'string' ? parseFloat(amount) : amount;
      if (isNaN(num)) return 'مبلغ نامعتبر';
      const [int, frac = ''] = num.toString().split('.');
      const formattedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return frac ? `${formattedInt}.${frac}` : formattedInt;
    },

    transactionStatus(status) {
      const map = { pending: 'در انتظار', '1': 'موفق', '3': 'نا موفق' };
      return map[status] || '';
    },

    transactionStyle(status) {
      const map = { pending: 'text-yellow-500', '1': 'text-green-500', '3': 'text-error-500' };
      return map[status] || '';
    }
  },

  created() {
    // Update `this.now` every second → triggers re-render
    this._clock = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },

  beforeUnmount() {
    if (this._clock) clearInterval(this._clock);
  }
};
</script>

<style lang="scss" scoped>
.external-transactions-table {
  border-collapse: separate;
  border-spacing: 0 10px;

  @screen md {
    @apply w-full mt-6;
  }

  .head {
    @screen md {
      @apply text-[#9AA0AD] text-sm font-[325px];
    }
  }

  .body .row {
    @screen md {
      @apply h-[55px];
    }
  }
}

/* Blue border for new transactions (3 minutes) */
.new-transaction {
  position: relative;
  border: 2px solid #3b82f6 !important;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(26, 76, 94, 0.4); /* #1A4C5E with opacity */
  animation: pulse-shadow 2s infinite;
}

@keyframes pulse-shadow {
  0%, 100% {
    box-shadow: 0 0 10px rgba(26, 76, 94, 0.4);
  }
  50% {
    box-shadow: 0 0 18px rgba(26, 76, 94, 0.7);
  }
}
</style>